//Componentes generales
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

//Rutas
import Routes_gral from "../../utils/Routes_gral";

//Permisos
import {
  VER_USUARIOS,
  VER_PRODUCTOS,
  VER_GRUPOS,
  VER_PROVEEDORES,
  VER_VALID_DATOS,
  VER_ABMS,
} from "../../utils/permisos";

//Estilos
import "./Navbar.css";

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faHouse,
  faIdCard,
  faObjectGroup,
  faMoneyBillTransfer,
  faListCheck,
  faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";

/*
  Componente encarado de las redirecciones de navegación de la pagina.
    Donde usuario es el usuario en sesión.
*/
const StyledNavbar_bottom = ({ usuario }) => {
  return (
    <div className="">
      <div className="navbar-xx">
        <nav className="navbar-container-xx">
          <NavLink to={Routes_gral.home} className="link navbar-item-xx">
            {" "}
            <FontAwesomeIcon icon={faHouse} className="icon-navbar" />{" "}
            <div className="navbar-item-label-xx">Home</div>
          </NavLink>

          {usuario.userType.some((item) =>
            VER_VALID_DATOS.includes(item.typeName)
          ) && (
            <NavLink
              to={Routes_gral.validDatos}
              className="link navbar-item-xx"
            >
              <FontAwesomeIcon icon={faIdCard} className="icon-navbar" />{" "}
              <div className="navbar-item-label-xx">Mis Datos</div>
            </NavLink>
          )}

          <NavLink to={Routes_gral.solicitudes} className="link navbar-item-xx">
            <FontAwesomeIcon icon={faListCheck} className="icon-navbar" />{" "}
            <div className="navbar-item-label-xx">Solicitudes</div>
          </NavLink>

          <NavLink
            to={Routes_gral.ctaCorriente}
            className="link navbar-item-xx"
          >
            <FontAwesomeIcon
              icon={faMoneyBillTransfer}
              className="icon-navbar"
            />{" "}
            <div className="navbar-item-label-xx">Cuenta Corriente</div>
          </NavLink>

          <NavLink to={Routes_gral.pagosYreten} className="link navbar-item-xx">
            <FontAwesomeIcon
              icon={faFileInvoiceDollar}
              className="icon-navbar"
            />{" "}
            <div className="navbar-item-label-xx">Pagos y Retenciones</div>
          </NavLink>
          { usuario.userType.some(item => VER_ABMS.includes(item.typeName)) &&
          <NavLink to={Routes_gral.abms} className='navbar-item-xx'> 
            <FontAwesomeIcon icon={faObjectGroup} className='icon-navbar'/> 
            <div className='navbar-item-label-xx' color="white">ABMs</div>
          </NavLink>
        }


        </nav>
      </div>
    </div>
  );
};
export default StyledNavbar_bottom;